import {
  Alert,
  Button,
  Grid,
  MenuItem,
  Select,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import { DropDownItem } from "../../../libs/ui/FormDropdownField";
import { ResourceSelectionType } from "../type";
import { ResourceImage } from "../../resources/SourceImage";

export const ResourceSelectItem = ({
  resources,
  resourceGroup,
  onChange,
  addNew = false,
  onAdd,
  onRemove,
  isShipped,
}: {
  resources: DropDownItem[];
  resourceGroup: ResourceSelectionType;
  onChange: (data: ResourceSelectionType) => void;
  addNew?: boolean;
  onAdd: () => void;
  onRemove: () => void;
  isShipped?: boolean;
}) => {
  const selectedResource: any = resources.find(
    (r) => r.value === resourceGroup.resource
  );

  const handleChange = (data: Partial<ResourceSelectionType>) => {
    const newResourceId =
      data.resource !== undefined ? data.resource : resourceGroup.resource;
    const newSelectedResource: any = resources.find(
      (r) => r.value === newResourceId
    );

    onChange({
      ...resourceGroup,
      ...data,
      inventory: newSelectedResource?.inventory,
      quantityInCase: newSelectedResource?.quantityInCase,
    });
  };

  
  const getOrderQty = () => {
    const calc =
      selectedResource?.quantityInCase * resourceGroup.cases +
      resourceGroup.singles;
    return isNaN(calc) ? "-" : calc;
  };

  return (
    <Grid container spacing={2} alignItems="center">
      {selectedResource?.imageUrl && (
        <Grid item xs={12} md={1} lg={0.5} my={1.5}>
          <ResourceImage
            url={selectedResource?.imageUrl}
            altString={selectedResource?.label}
          />
        </Grid>
      )}

      <Grid
        item
        xs={12}
        md={selectedResource?.imageUrl ? 2 : 3}
        lg={selectedResource?.imageUrl ? 2 : 2.5}
        my={1.5}
      >
        <Stack sx={{ width: "100%" }}>
          <Select
            labelId={`select-dropdown-resource-label`}
            id={`select-dropdown-resource`}
            disabled={isShipped}
            value={
              isNaN(resourceGroup.resource as any) ? 0 : resourceGroup.resource
            }
            fullWidth
            MenuProps={{
              PaperProps: {
                style: {
                  maxHeight: 300,
                },
              },
            }}
            size={"small"}
            onChange={(e) => {
              handleChange({ resource: Number(e.target.value) as any });
            }}
          >
            {resources.map((option, index) => (
              <MenuItem
                key={`${option.value}-${option.label}`}
                value={option.value}
              >
                {option.label}
              </MenuItem>
            ))}
          </Select>
        </Stack>
      </Grid>
      <Grid item xs={12} md={2} lg={1.5} my={1.5}>
        <Grid container direction="row" spacing={2}>
          <Grid item xs={5}>
            <Typography
              sx={{
                fontSize: 16,
                fontWeight: "400",
                minWidth: "100px",
                lineHeight: "40px",
              }}
            >
              Cases QTY
            </Typography>
          </Grid>
          <Grid item xs={6}>
            <TextField
              onChange={(e) => {
                const newCases = Math.max(0, Number(e.target.value));
                handleChange({ cases: newCases as any });
              }}
              value={
                selectedResource?.quantityInCase
                  ? selectedResource?.quantityInCase
                  : "-"
              }
              fullWidth
              disabled
              size="small"
            />
          </Grid>
        </Grid>
      </Grid>
      <Grid item xs={12} md={2} lg={2} my={1.5}>
        <Grid container direction="row" spacing={2}>
          <Grid item xs={5}>
            <Typography
              sx={{
                fontSize: 16,
                fontWeight: "400",
                minWidth: "100px",
                lineHeight: "40px",
              }}
            >
              Order QTY
            </Typography>
          </Grid>
          <Grid item xs={6}>
            <TextField value={getOrderQty()} fullWidth disabled size="small" />
          </Grid>
        </Grid>
      </Grid>
      <Grid item xs={12} md={2} lg={2} my={1.5}>
        <Grid container direction="row" spacing={2}>
          <Grid item xs={4}>
            <Typography
              sx={{
                fontSize: 16,
                fontWeight: "400",
                minWidth: "100px",
                lineHeight: "40px",
              }}
            >
              Cases
            </Typography>
          </Grid>
          <Grid item xs={7}>
            <TextField
              disabled={isShipped}
              onChange={(e) => {
                const newCases = Math.max(0, Number(e.target.value));
                handleChange({ cases: newCases as any });
              }}
              value={resourceGroup.cases}
              fullWidth
              type="number"
              size="small"
            />
          </Grid>
        </Grid>
      </Grid>
      <Grid item xs={12} md={2} lg={2} my={1.5}>
        <Grid container direction="row" spacing={2}>
          <Grid item xs={4}>
            <Typography
              sx={{
                fontSize: 16,
                fontWeight: "400",
                minWidth: "100px",
                lineHeight: "40px",
              }}
            >
              Singles
            </Typography>
          </Grid>
          <Grid item xs={7}>
            <TextField
              disabled={isShipped}
              onChange={(e) => {
                handleChange({ singles: Math.max(0, Number(e.target.value)) });
              }}
              value={resourceGroup.singles}
              fullWidth
              type="number"
              size="small"
            />
          </Grid>
        </Grid>
      </Grid>
      
      
      <Grid item xs={12} md={2} lg={2} my={1.5}>
        <Grid container spacing={2}>
          {addNew && (
            <Grid item xs={6}>
              <Button
                disabled={isShipped}
                fullWidth
                variant="outlined"
                onClick={onAdd}
              >
                Add
              </Button>
            </Grid>
          )}

          <Grid item xs={6}>
            <Button
              disabled={isShipped}
              fullWidth
              variant="outlined"
              onClick={onRemove}
            >
              Remove
            </Button>
          </Grid>
        </Grid>
      </Grid>
      {
        getOrderQty() > selectedResource?.inventory && (
          <Grid item xs={12}>
            <Alert 
                severity='error'
                sx={{
                  '& .MuiAlert-message': {
                    fontSize: '0.9rem',
                    fontWeight: 500
                  }
                }}
              >
                  {`The inventory selected for '${selectedResource.label}' cannot exceed the current inventory level of ${selectedResource?.inventory}. Please adjust the order quantity.`}
              </Alert>
          </Grid>
        )
      }
    </Grid>
  );
};
